import angular from 'angular';

export default angular
    .module('shared')
    .constant('billingOverviewEventConstants', {
        paymentMethodUpdated: 'paymentMethodUpdated',
        makePaymentSuccess: 'makePaymentSuccess',
        upgradeSubscriptionSuccess: 'upgradeSubscriptionSuccess'
    });



// WEBPACK FOOTER //
// ./modules/shared/constants/billingOverviewEvent.constant.js